import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Courier } from "../_models/courier.js";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CourierService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getCouriers() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.couriers}/`;
    return this.http.get<Courier[]>(requestUrl, options);
  }
  
  public getCourier(courierId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.couriers}/${courierId}/`;
    return this.http.get<Courier>(requestUrl, options);
  }

  public addCourier(courier: Courier): Observable<Courier> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.couriers}/`;
    console.log(requestUrl);
    return this.http.post<Courier>(requestUrl, courier, options);
  }

  public updateCourier(courier: Courier): Observable<Courier> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.couriers}/`;
    console.log(requestUrl);
    return this.http.put<Courier>(requestUrl, courier, options);
  }

  public deleteCourier(courierId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.couriers}/${courierId}/`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
